import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const taxAdjustmentOptions = [
  { value: 'Tax Refund via RTGS', label: 'Tax Refund via RTGS' },
  { value: "Tax Refund via Manager's Check", label: "Tax Refund via Manager's Check" },
  { value: 'Tax Return Endorsement', label: 'Tax Return Endorsement' }
];

const ModalTaxAdjustmentDetails = ({
  show,
  onClose,
  onConfirm,
  paymentDates = [],
  existingTaxAdjustments = [] // Changed prop name to reflect both bpId and type
}) => {
  const [bpId, setBpId] = useState('');
  const [taxAdjustmentType, setTaxAdjustmentType] = useState(taxAdjustmentOptions[0].value);
  const [amount, setAmount] = useState('');
  const [selectedPaymentDate, setSelectedPaymentDate] = useState('');
  const [showDuplicateError, setShowDuplicateError] = useState(false);

  // Reset form values when modal is opened
  useEffect(() => {
    if (show) {
      setBpId('');
      setTaxAdjustmentType(taxAdjustmentOptions[0].value);
      setAmount('');
      setSelectedPaymentDate(paymentDates.length > 0 ? paymentDates[0] : '');
      setShowDuplicateError(false);
    }
  }, [show, paymentDates]);

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^\d+(\.\d{0,2})?$/.test(value)) {
      setAmount(value);
    }
  };

  const handleConfirm = () => {
    if (!bpId.trim() || bpId.length !== 11) {
      alert('BPID must be exactly 11 characters long.');
      return;
    }
    // Check for duplicate: same BPID and same tax adjustment type
    if (
      existingTaxAdjustments.some(
        (entry) =>
          entry.bpId.trim() === bpId.trim() &&
          entry.taxAdjustmentType === taxAdjustmentType
      )
    ) {
      setShowDuplicateError(true);
      return;
    }
    // Validate amount only if taxAdjustmentType is not Tax Return Endorsement
    if (taxAdjustmentType !== 'Tax Return Endorsement') {
      if (!amount.trim() || isNaN(parseFloat(amount))) {
        alert('Please enter a valid amount.');
        return;
      }
    }
    if (!selectedPaymentDate) {
      alert('Please select a Payment Date.');
      return;
    }
    onConfirm({
      bpId: bpId.trim(),
      taxAdjustmentType,
      amount: taxAdjustmentType !== 'Tax Return Endorsement' ? parseFloat(amount).toFixed(2) : '',
      paymentDate: selectedPaymentDate
    });
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enter Tax Adjustment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Enter BPID</Form.Label>
              <Form.Control
                type="text"
                value={bpId}
                onChange={(e) => setBpId(e.target.value)}
                placeholder="Enter BPID (11 characters)"
                maxLength={11}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Type of Tax Adjustment</Form.Label>
              <Form.Control
                as="select"
                value={taxAdjustmentType}
                onChange={(e) => setTaxAdjustmentType(e.target.value)}
              >
                {taxAdjustmentOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            {taxAdjustmentType !== 'Tax Return Endorsement' && (
              <Form.Group className="mb-3">
                <Form.Label>Enter Amount</Form.Label>
                <Form.Control
                  type="text"
                  value={amount}
                  onChange={handleAmountChange}
                  placeholder="Enter amount"
                />
              </Form.Group>
            )}
            <Form.Group className="mb-3">
              <Form.Label>Payment Date</Form.Label>
              <Form.Control
                as="select"
                value={selectedPaymentDate}
                onChange={(e) => setSelectedPaymentDate(e.target.value)}
              >
                {paymentDates.map((date) => (
                  <option key={date} value={date}>
                    {date}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Go Back
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Duplicate Error Modal */}
      <Modal
        show={showDuplicateError}
        onHide={() => setShowDuplicateError(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Duplicate BPID detected for the selected tax adjustment type. Please enter unique details.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDuplicateError(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalTaxAdjustmentDetails;
